<template>
    <div :class="{ 'rt-select-control': true, 'floating-select': type === 'floating', 'selected': selectedValue }">
        <select ref="select" class="rt-select__field"
            :name="name"
            :disabled="disabled"
            :autofocus="autofocus"
            @change="onChangeSelect"
        >
            <option v-for="(optionValue, idx) in options" :key="idx" :value="idx" :selected="selectedValue === idx">{{ optionValue }}</option>
        </select>
        <div class="rt-select__floating-control-wrapper" @click="focus" v-if="type === 'floating' && selectedValue">
            <div class="floating-placeholder">{{ getFloatingLabel() }}</div>
            <div class="floating-select-info">{{ getSelectedInfo() }}</div>
        </div>
    </div>
</template>

<script>
    import _ from 'lodash';
    import RtPicture from './Picture.vue';

    export default {
        watch: {
            'value'(newVal) {
                this.selectedValue = newVal;
            }
        },
        data: function () {
            return {
                selectedValue: 0
            }
        },
        mounted() {
            this.selectedValue = this.value;
        },
        methods: {
          focus() {
            this.$refs.select.trigger('mousedown');
          },
          getSelectedInfo() {
            return this.options[this.selectedValue]
          },
          getFloatingLabel() {
            return this.floatLabel || 'Select Class';
          },
          onChangeSelect(event) {
            const newValue = parseInt(event.target.value);
            if (this.min > 0 && newValue < this.min) {
              this.selectedValue = this.min;
            } else {
              this.selectedValue = newValue;
            }
            this.$emit('change', this.selectedValue);
          }
        },
        props: ['name','disabled', 'autofocus', 'value', 'options','type', 'floatLabel', 'min'],
        components: {
            RtPicture
        }
    }
</script>

<style scoped lang="scss">

    @import './variables';

    .rt-select-control {
        &.floating-select {
            position: relative;
            width: 15rem;
            height: 50px;
            &.selected {
                .rt-select__field {
                    color: transparent;
                }        
            }
        }
    }

    .rt-select__field {
        width: 100%;
        background: rgba(238, 245, 255, 0.7);
        padding: 14px 18px;
        border-color: transparent;
        border-radius: 5px;
        font-family: $text-font;
        font-size: 1rem;
        color: $grey-100;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url('/assets/app/signup/icon-dropdown.svg');
        background-repeat: no-repeat;
        background-position: calc(100% - 1.25rem) 22px;

        &:focus {
            box-shadow: 0 0 5px $primary-blue;
        }
        &.error {
          border: 1px solid $red;
        }
        option {
            color: $grey-100;
        }
    }

    .rt-select__floating-control-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 0.56rem 2rem 0.62rem 1.12rem;
        pointer-events: none;

        .floating-placeholder {
            font-size: 0.75rem;
            line-height: 1;
            color: $grey-100;
        }

        .floating-select-info {
            font-size: 1rem;
            font-weight: 500;
            color: #333;
            // crop long text
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

</style>
